import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  fetchEventSourceKeyWhitelist,
  updateEventSourceKeyWhitelist,
} from "../api/fetch-event-source-key-whitelist";

const QUERY_KEY = "event-source-key-whitelist";

export function useEventSourceKeyWhitelist(clientUid?: string) {
  return useQuery({
    queryKey: [QUERY_KEY, clientUid],
    queryFn: () => fetchEventSourceKeyWhitelist(clientUid!),
    enabled: !!clientUid,
  });
}

export function useUpdateEventSourceKeyWhitelist(clientUid?: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (keywords: string[]) =>
      updateEventSourceKeyWhitelist(clientUid!, keywords),
    onSuccess: (data) => {
      queryClient.setQueryData([QUERY_KEY, clientUid], data);
    },
  });
}
